// Modules
import { combineReducers } from 'redux'

// Reducers
import activeTradeItemsReducer from 'store/reducers/activeTradeItemsReducer'
import authReducer from 'store/reducers/authReducer'
import currencySocketReducer from 'store/reducers/currencySockets/currencySocketReducer'
import marketSidebarReducer from 'store/reducers/currencySockets/marketSidebarReducer'
import favouritesCurrencyListReducer from 'store/reducers/favouritesCurrencyListReducer'
import infoModalTradeItemReducer from 'store/reducers/infoModalTradeItemReducer'
import mainGraphBlockWidthReducer from 'store/reducers/mainGraphBlockWidthReducer'
import orderBarReducer from 'store/reducers/orderBarReducer'
import toastsReducer from 'store/reducers/toastsReducer'
import transactionCreationReducer from 'store/reducers/transactionCreationReducer'
import userDepositReducer from 'store/reducers/userDepositReducer'
import userReducer from 'store/reducers/userReducer'
import withdrawalReducer from 'store/reducers/withdrawalReducer'
import chatReducer from 'store/reducers/chat'
import signalsReducer from 'store/reducers/signalsReducer'

import kycReducer from './kycReducer'

const rootReducer = combineReducers({
  activeTradeItems: activeTradeItemsReducer,
  infoModalTradeItem: infoModalTradeItemReducer,
  mainGraphBlockWidth: mainGraphBlockWidthReducer,
  marketSidebar: marketSidebarReducer,
  orderBar: orderBarReducer,
  user: userReducer,
  withdrawal: withdrawalReducer,
  auth: authReducer,
  toastsApp: toastsReducer,
  favouritesCurrencyList: favouritesCurrencyListReducer,
  currencySocket: currencySocketReducer,
  transactionCreation: transactionCreationReducer,
  kyc: kycReducer,
  userDeposit: userDepositReducer,
  chat: chatReducer,
  signals: signalsReducer,
})

export default rootReducer
